module.exports = "<svg id=\"i-info\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\">\n    <path d=\"M16 14 L16 23 M16 8 L16 10\" />\n    <circle cx=\"16\" cy=\"16\" r=\"14\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/svg/info.svg
// module id = 88
// module chunks = 0